import  { useState } from 'react'
import { sendOtpApi, UserCreateAPI, VerifyOtpApi } from '../Services/Operations/ProductAPI'
import { toast } from "react-toastify";
import { useNavigate } from 'react-router';
import { useDispatch } from 'react-redux';
import { setSignupData, setuserId } from '../Redux/user_information';

const Register = () => {
    const[firstName,setFirstName]=useState("")
    const[middleName,setMiddleName]=useState("")
    const[lastName,setLastName]=useState("")
    const[dob,setDateOfBirth]=useState(null)
    const[age,setAge]=useState(0)
    const[gender,setGender]=useState("")
    const[co,setCareOf]=useState("")
    const[houseBuildingApartment,setHouseBuildingApartment]=useState("")
    const[streetRoadLane,setStreetRoadLane]=useState("")
    const[areaLocalitySector,setAreaLocalitySector]=useState("")
    const[villageTownCity,setVillageTownCity]=useState("")
    const[postOffice,setPostOffice]=useState("")
    const[district,setDistrict]=useState("")
    const[subDistrict,setSubDistrict]=useState("")
    const[ state,setState]=useState("")
    const[pincode,setPincode]=useState(0)
    const[primaryNumber,setPrimaryNumber]=useState("")
    const[secondaryNumber,setSecondaryNumber]=useState("")
    const[resume,setResume]=useState(null)
    const[email,setEmail]=useState("")
    const[password,setPassword]=useState("")
    const[otp,setOtp]=useState("")
    const[step,setStep]=useState(1)
    const[loading,setLoading]=useState(false)

    const navigate=useNavigate()
    const dispatch=useDispatch()

const handleFileChange = (e) => {
    setResume(e.target.files[0]);  // get the selected file
  };

 const handleSendPhone = async () => {
    if (!primaryNumber.match(/^\d{10}$/)) {
      toast.error("Please enter a valid 10-digit phone number.");
      return;
    }
    setLoading(true)
    try {
     const response= await sendOtpApi(primaryNumber);
     console.log(response);
     
      toast.success("OTP sent successfully!");
      setStep(2);
    } catch(error) {
      toast.error("Failed to send OTP. Please try again.");
      
    }
    finally{
      setLoading(false)
    }
  };

const registerOtp=async()=>{
      

        const formData = new FormData();
    formData.append('resume', resume);
        let data={
            firstName,
            middleName,
            lastName,
            dob,
            otp,
            age,
            gender,
            co,
            houseBuildingApartment,
            streetRoadLane,
            areaLocalitySector,
            villageTownCity,
            postOffice,
            district,
            subDistrict,
            state,
            pincode,
            primaryNumber,
            secondaryNumber,
            resume:null,
            email,
            password,
            landmark:""
        }
        console.log(data);
        
        try {
          setLoading(true)

          const res= await VerifyOtpApi(primaryNumber, otp);
                console.log("response : ", res);

           toast.success("OTP verified successfully!");
       const response=await UserCreateAPI(data)

            console.log(response);

            if(response.id===0){
              navigate("/login")
            }else{
              dispatch(setuserId(response.data.id))
              dispatch(setSignupData(response.data.token))
            navigate("/")
            }

            
            
        } catch (error) {
            console.log(error);
            navigate("/login")
            
        }finally{
          setLoading(false)
        }
    }

  return (
    <div className='flex flex-col items-center justify-center w-[100%] sm:w-[80%]'>
        <h1>Register New  user</h1>

        <form className='flex flex-col items-center py-6 px-[30px] border-1 mx-[20%] rounded-md'>
          <div className={`flex flex-col items-start gap-6 sm:flex-row`}>
          <div>
            <label className='text-[15px] font-bold'>First name <span style={{color:"red"}}>*</span></label>
             <input value={firstName} onChange={(e)=>setFirstName(e.target.value)}
             placeholder='First name' type='text' className='h-[20px] w-[40%]'/>

             <label className='text-[15px] font-bold'>Middle name </label>
            <input value={middleName} onChange={(e)=>setMiddleName(e.target.value)}
             placeholder='Middle name'  type='text' className='h-[20px] w-[50%]'/>

             <label className='text-[15px] font-bold'>Last name <span style={{color:"red"}}>*</span></label>
            <input value={lastName} onChange={(e)=>setLastName(e.target.value)}
            placeholder='Last name' type='text' className='h-[20px] w-[50%]'/>

            <label className='text-[15px] font-bold'>Date of Birth<span style={{color:"red"}}>*</span></label>
            <input value={dob} onChange={(e)=>setDateOfBirth(e.target.value)}
            placeholder='Date of Birth' type='date'  className='h-[20px] w-[50%]'/>

            <label className='text-[15px] font-bold'>Age <span style={{color:"red"}}>*</span></label>
            <input value={age} onChange={(e)=>setAge(e.target.value)}
            placeholder='Age' type='number' className='h-[20px] w-[50%]'/>

            <label className='text-[15px] font-bold'>Gender <span style={{color:"red"}}>*</span></label>
            <input value={gender} onChange={(e)=>setGender(e.target.value)}
            placeholder='Gender'type='text' className='h-[20px] w-[50%]'/>

            <label className='text-[15px] font-bold'>Care of</label>
            <input value={co} onChange={(e)=>setCareOf(e.target.value)}
            placeholder='Care of' type='text' className='h-[20px] w-[50%]'/>

            <label className='text-[15px] font-bold'>Email<span style={{color:"red"}}>*</span></label>
             <input value={email} onChange={(e)=>setEmail(e.target.value)}
            placeholder='Email'type='email' className='h-[20px] w-[50%]'/>

            <label className='text-[15px] font-bold'>Password <span style={{color:"red"}}>*</span></label>
            <input value={password} onChange={(e)=>setPassword(e.target.value)}
            placeholder='Password'type='password' className='h-[20px] w-[50%]'/>

            <label className='text-[15px] font-bold'>Primary ph number <span style={{color:"red"}}>*</span></label>
             <input value={primaryNumber} onChange={(e)=>setPrimaryNumber(e.target.value)}
            placeholder='Primary Number'type='text' className='h-[20px] w-[50%]'/>

            <label className='text-[15px] font-bold'>Secondary number</label>
            <input value={secondaryNumber} onChange={(e)=>setSecondaryNumber(e.target.value)}
            placeholder='Secondary Number'type='text' className='h-[20px] w-[50%]'/>
          </div>
           <div>
            <label className='text-[15px] font-bold'>House Building Apartment <span style={{color:"red"}}>*</span></label>
            <input value={houseBuildingApartment} onChange={(e)=>setHouseBuildingApartment(e.target.value)}
            placeholder='House Building Apartment name'type='text' className='h-[20px] w-[50%]'/>
            <label className='text-[15px] font-bold'>Street Road Lane <span style={{color:"red"}}>*</span></label>
            <input value={streetRoadLane} onChange={(e)=>setStreetRoadLane(e.target.value)}
            placeholder='Street Road Lane Name'type='text' className='h-[20px] w-[50%]'/>
            <label className='text-[15px] font-bold'>Area Locality Sector <span style={{color:"red"}}>*</span></label>
            <input value={areaLocalitySector} onChange={(e)=>setAreaLocalitySector(e.target.value)}
            placeholder='Area Locality Sector'type='text' className='h-[20px] w-[50%]'/>
            <label className='text-[15px] font-bold'>Village Town City <span style={{color:"red"}}>*</span></label>
            <input value={villageTownCity} onChange={(e)=>setVillageTownCity(e.target.value)}
            placeholder='Village Town City'type='text' className='h-[20px] w-[50%]'/>
            <label className='text-[15px] font-bold'>Post office <span style={{color:"red"}}>*</span></label>
            <input value={postOffice} onChange={(e)=>setPostOffice(e.target.value)}
            placeholder='Post Office'type='text' className='h-[20px] w-[50%]'/>
            <label className='text-[15px] font-bold'>District <span style={{color:"red"}}>*</span></label>
            <input value={district} onChange={(e)=>setDistrict(e.target.value)}
            placeholder='District'type='text' className='h-[20px] w-[50%]'/>
            <label className='text-[15px] font-bold'>Sub district <span style={{color:"red"}}>*</span></label>
            <input value={subDistrict} onChange={(e)=>setSubDistrict(e.target.value)}
            placeholder='Sub District'type='text' className='h-[20px] w-[50%]'/>
            <label className='text-[15px] font-bold'>State <span style={{color:"red"}}>*</span></label>
            <input value={state} onChange={(e)=>setState(e.target.value)}
            placeholder='State'type='text' className='h-[20px] w-[50%]'/>
            <label className='text-[15px] font-bold'>Pincode <span style={{color:"red"}}>*</span></label>
            <input value={pincode} onChange={(e)=>setPincode(e.target.value)}
            placeholder='Pincode'type='number' className='h-[20px] w-[50%]'/>
            <label className='text-[15px] font-bold'>Resume </label>
            <input  onChange={handleFileChange}
            placeholder='resume' type='file' className='h-fit w-[50%]'/>
           </div>
           </div>
            
           

            
          {step===2?<div className='flex flex-col items-center p-7 border-1'><input value={otp} onChange={(e)=>setOtp(e.target.value)}/>
        <p onClick={registerOtp}  className='p-2 rounded-lg bg-orange-400 cursor-pointer font-bold text-white hover:bg-gray-600 w-fit'>
          {!loading?"verify and register":"...."}</p></div>:
         <p onClick={handleSendPhone}
             className='p-2 rounded-lg bg-orange-400 cursor-pointer font-bold text-white hover:bg-gray-600'> {!loading?"Send OTP":"...."}</p>
             }
        </form>

     
    </div>
  )
}

export default Register